/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Geringfuegigebeschaeftigunggewuenscht2Inputs */



/**

* @param {_Field_Geringfuegigebeschaeftigunggewuenscht2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_geringfuegigebeschaeftigunggewuenscht2 = /** @type {((inputs?: _Field_Geringfuegigebeschaeftigunggewuenscht2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Geringfuegigebeschaeftigunggewuenscht2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Geringfügige Beschäftigung gewünscht")
});
export { _field_geringfuegigebeschaeftigunggewuenscht2 as "_field_geringfuegigeBeschaeftigungGewuenscht" }